<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <SearchTitle label='住培生月度绩效考评' label2="tips：1.填写评分内容后保存。2.下载凭证。3.上传签字凭证。4.提交。" url='/achievement/stu/scorerecordlist'></SearchTitle>
      <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
        <!--begin: Search Form -->
        <div class="m-form m-form--label-align-right">
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">管理单元：</label>
              </div>
              <div class="m-form__control">
                <el-select v-model="condition.secretarysec" filterable placeholder="全部">
                  <el-option label="全部" value=""></el-option>
                  <el-option v-for="item in managesecOptions" :key="item.DictItemID" :label="item.DictItemName" :value="item.DictItemID">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">考核月份：</label>
              </div>
              <div class="m-form__control">
                <el-date-picker v-model="condition.cpidate" type="month" placeholder="考核月份" value-format="yyyy-MM">
                </el-date-picker>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">状态：</label>
              </div>
              <div class="m-form__control">
                <el-select v-model="condition.cpistatus" filterable placeholder="全部">
                  <el-option label="全部" value=""></el-option>
                  <el-option v-for="item in cpistatusOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
        </div>
        <div style="clear: both;"></div>
        <div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;float: initial;">
          <SearchButton :url='searchUrl' ref="btnSearch"></SearchButton>
          <AddButton url="/achievement/stu/score" buttonname="新增" v-if="issecretary == 1"></AddButton>
          <!-- <ImportButton url="/achievement/stu/import" buttonname="导入"></ImportButton> -->
          <!-- <el-button type="primary" icon="el-icon-search" @click="UpdateCPI">数据调整</el-button> -->
        </div>
        <!--end: Search Form -->
        <!--begin: Datatable -->
        <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
          <el-table v-loading="loading" :data="tableData" stripe style="width: 100%" size="medium">
            <el-table-column prop="SecName" label="管理单元">
            </el-table-column>
            <el-table-column label="月度">
              <template slot-scope="scope">
                {{scope.row.CPIDate|formatDate}}
              </template>
            </el-table-column>
            <!-- <el-table-column label="签字凭证">
              <template slot-scope="scope">
                <div v-if="scope.row.CPIStatus=='1' || scope.row.CPIStatus=='4'">
                  <div v-if="scope.row.CPIFile=='' || scope.row.CPIFile==null">
                    <div style="float: left;width: 40px;height: 25px;line-height: 25px;">无</div>
                    <div style="float: left;width: 75px;height: 25px;line-height: 25px;" v-if="issecretary == 1">
                      <el-upload class="upload-demo" ref="upload" :action='uploadUrl' :data="{id:scope.row.CPIID}"
                        :limit="1" :on-success="handleAvatarSuccess" :show-file-list="false">
                        <a style="color:#66b1ff">[上传]</a>
                      </el-upload>
                    </div>
                  </div>
                  <div v-if="scope.row.CPIFile!='' && scope.row.CPIFile!=null">
                    <div style="float: left;width: 40px;height: 25px;line-height: 25px;">
                      <span @click="See(scope.row)" style="color: rgb(102, 177, 255);cursor: pointer;">查看</span>
                    </div>
                    <div style="float: left;width: 75px;height: 25px;line-height: 25px;" v-if="issecretary == 1">
                      <el-upload class="upload-demo" ref="upload" :action='uploadUrl' :data="{id:scope.row.CPIID}"
                        :limit="1" :on-success="handleAvatarSuccess" :show-file-list="false">
                        <a style="color:#66b1ff">[重新上传]</a>
                      </el-upload>
                    </div>
                    <div style="clear: both;"></div>
                    <div>
                      {{scope.row.CPIFileDate}}
                    </div>
                  </div>
                </div>
                <div v-if="scope.row.CPIStatus=='2' || scope.row.CPIStatus=='3'">
                  <div v-if="scope.row.CPIFile=='' || scope.row.CPIFile==null">
                    <div style="float: left;width: 40px;height: 25px;line-height: 25px;">无</div>
                  </div>
                  <div v-if="scope.row.CPIFile!='' && scope.row.CPIFile!=null">
                    <div style="float: left;width: 40px;height: 25px;line-height: 25px;">
                      <span @click="See(scope.row)" style="color: rgb(102, 177, 255);cursor: pointer;">查看</span>
                    </div>
                    <div style="clear: both;"></div>
                    <div>
                      {{scope.row.CPIFileDate}}
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column> -->
            <el-table-column prop="CPIStatusName" label="状态">
            </el-table-column>
            <el-table-column label="操作" width="220" v-if="issecretary == 1">
              <template slot-scope="scope">
                <el-button @click="Edit(scope.row)" type="text" size="medium" v-if="scope.row.CPIStatus=='1' || scope.row.CPIStatus=='4'">修改</el-button>
                <el-button @click="Info(scope.row)" type="text" size="medium">详细</el-button>
                <el-button @click="DownFile(scope.row)" type="text" size="medium">下载凭证</el-button>
                <!-- <el-button @click="Up(scope.row)" type="text" size="medium" v-if="(scope.row.CPIStatus=='1' || scope.row.CPIStatus=='4') && (scope.row.CPIFile!='' && scope.row.CPIFile!=null)">提交</el-button> -->
              </template>
            </el-table-column>
            <el-table-column label="操作" width="80" v-if="issecretary == 0">
              <template slot-scope="scope">
                <el-button @click="Info(scope.row)" type="text" size="medium">详细</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!--end: Datatable -->
          <div style="margin-top: 10px;text-align: center;" v-if="this.condition.recordCount > 0">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="condition.currentPage"
              :page-sizes="[2, 10, 20, 30, 40]" :page-size="condition.pageSize" layout="total, sizes, prev, pager, next, jumper"
              :total="condition.recordCount">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // import docxtemplater from 'docxtemplater'
  // import JSZipUtils from 'jszip-utils'
  // import saveAs from 'file-saver'
  // import JSZip from 'jszip'
  export default {
    name: 'ScoreRecordList',
    data() {
      return {
        condition: {
          token: '',
          username: '',
          rolelevel: '',
          secid: '',
          cpitype: '1',
          cpidate: '',
          cpistatus: '',
          pageSize: 10,
          currentPage: 1,
          recordCount: 0,
          firstSearch: true,
          secretarysec: ''
        },
        record: {
          ManageSecName: '',
          Month: '',
        },
        tableData: null,
        cpistatusOptions: [{
          value: '1',
          label: '已保存'
        }, {
          value: '2',
          label: '已提交'
        }, {
          value: '3',
          label: '审核通过'
        }, {
          value: '4',
          label: '退回'
        }],
        searchUrl: this.$utils.Url.zpgl + '/api/APICPI/List',
        uploadUrl: this.$utils.Url.zpgl + '/api/APICPI/UploadCPIFile',
        loading: true,
        secOptions: [],
        managesecOptions: [],
        issecretary: 0
      }
    },
    filters: {
      formatDate(val) {
        var now = new Date(val)
        var y = now.getFullYear()
        var m = now.getMonth() + 1
        return y + '-' + (m < 10 ? '0' + m : m)
      },
      formatFullDate(val) {
        var now = new Date(val)
        var y = now.getFullYear()
        var m = now.getMonth() + 1
        var d = now.getDate()
        return y + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d)
      }
    },
    methods: {
      See: function(row) {
        var url = this.$utils.Url.zpgl + '/file/' + row.CPIFile
        window.open(url)
      },
      DownFile: function(row) {
        var cpidate = row.CPIDate
        var date = new Date(cpidate)
        var year = date.getFullYear()
        var month = date.getMonth() + 1
        if (month > 12) {
          year = year + 1
          month = 1
        }
        if (month >= 1 && month <= 9) {
          month = '0' + month
        }
        this.record.Month = year + '年' + month + '月'

        var args = {
          token: this.condition.token,
          id: row.CPIID
        }
        // var that = this
        // this.$http.post(this.$utils.Url.zpgl + '/api/APICPI/GetStuCPID', args)
        //   .then(res => {
        //     if (res.data.Code === 0) {
        //       console.log(res.data.Data)
        //       console.log(JSON.parse(res.data.Data))
        //       that.tempdata = JSON.parse(res.data.Data)
        //       JSZipUtils.getBinaryContent("/moneygranteetailtemp.docx", function(error, content) {
        //         if (error) {
        //           console.log(error.message)
        //           that.$message({
        //             message: '导出失败,' + error.message,
        //             type: 'error'
        //           })
        //         }
        //         let zip = new JSZip(content)
        //         let doc = new docxtemplater().loadZip(zip)
        //         console.log(that.tempdata)
        //         doc.setData({
        //           ...that.record,
        //           table: that.tempdata
        //         })
        //         try {
        //           // 用模板变量的值替换所有模板变量
        //           doc.render();
        //         } catch (error) {
        //           console.log(error.message)
        //           that.$message({
        //             message: '导出失败,' + error.message,
        //             type: 'error'
        //           })
        //         }
        //         // 生成一个代表docxtemplater对象的zip文件（不是一个真实的文件，而是在内存中的表示）
        //         let out = doc.getZip().generate({
        //           type: "blob",
        //           mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        //         });
        //         // 将目标文件对象保存为目标类型的文件，并命名
        //         saveAs(out, that.record.ManageSecName + that.record.Month + "住院(全科)医师规范化培训学员考核汇总表.docx");
        //         that.noticeVisible = false
        //       })
        //     } else {
        //       this.$message({
        //         message: '下载失败,' + res.data.Msg,
        //         type: 'error'
        //       })
        //     }
        //   })
        //   .catch(err => {
        //     console.log(err)
        //     this.$message({
        //       message: '下载失败',
        //       type: 'error'
        //     })
        //   })
        this.$http.post(this.$utils.Url.zpgl + '/api/APICPI/DownStuFile', args)
          .then(res => {
            if (res.data.Code === 0) {
              var filename = res.data.Data
              // var url = this.$utils.Url.zpgl + '/doc/' + filename
              var url = this.$utils.Url.zpgl + '/pdf/' + filename
              window.open(url)
            } else {
              this.$message({
                message: res.data.Data,
                type: 'error'
              })
            }
          })
          .catch(err => {
            console.log(err)
            this.$message({
              message: '下载失败',
              type: 'error'
            })
          })
      },
      // 调整每页显示数
      handleCurrentChange: function(val) {
        this.condition.firstSearch = false
        this.condition.currentPage = val
        this.$refs.btnSearch.Search()
      },
      // 分页操作
      handleSizeChange: function(val) {
        this.condition.firstSearch = false
        this.condition.pageSize = val
        this.condition.currentPage = 1
        this.$refs.btnSearch.Search()
      },
      handleAvatarSuccess: function(res) {
        if (res.Code === 0) {
          this.$message({
            message: '上传成功',
            type: 'success'
          })
          this.$refs.upload.clearFiles()
          this.$refs.btnSearch.Search()
        } else {
          this.$message({
            message: res.Msg + '，' + res.Error,
            type: 'error'
          })
        }
      },
      Edit: function(row) {
        this.$router.push({
          name: 'StuScoreEdit',
          params: {
            id: row.CPIID
          }
        })
      },
      Info: function(row) {
        this.$router.push({
          name: 'StuScoreReocrd',
          params: {
            id: row.CPIID
          }
        })
      },
      Up: function(row) {
        var args = {
          id: row.CPIID,
          cpistatus: 2,
          token: this.condition.token
        }
        var fd = this.$options.filters['formatDate']
        this.$confirm('确认提交 ' + fd(row.CPIDate) + ' 的住培生绩效考评信息吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.post(this.$utils.Url.zpgl + '/api/APICPI/Up', args)
            .then(res => {
              console.log(res.data)
              if (res.data.Code === 0) {
                this.$message({
                  message: '提交成功',
                  type: 'success'
                })
                console.log('刷新页面')
                this.$refs.btnSearch.Search()
              } else {
                this.$message({
                  message: res.data.Msg + '，' + res.data.Error,
                  type: 'error'
                })
              }
            })
            .catch(err => {
              console.log(err)
              this.$message({
                message: '提交失败',
                type: 'error'
              })
            })
        }).catch(() => {})
      },
      UpdateCPI: function() {
        this.loading = true
        var args = {
          pageSize: 999,
          currentPage: 1,
        }
        this.$http.post(this.$utils.Url.zpgl + '/api/APIMoneyGrant/UpdateCPI', args)
          .then(res => {
            if (res.data.Code === 0) {
              this.$message({
                message: '数据调整成功',
                type: 'success'
              })
            } else {
              this.$message({
                message: res.data.Msg + '，' + res.data.Error,
                type: 'error'
              })
            }
            this.loading = false
          })
          .catch(err => {
            console.log(err)
            this.$message({
              message: '数据调整失败',
              type: 'error'
            })
            this.loading = false
          })
      },
      LoadManageSec: function() {
        var args = {
          token: this.condition.token,
          username: this.condition.username,
          rolelevel: this.condition.rolelevel
        }
        var that = this
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIDictItem/ManageSecionList', args, function(data) {
          that.managesecOptions = data.Data
        }, null, null, null)
      },
      LoadRolePower: function() {
        var args = {
          token: this.condition.token,
          username: this.condition.username,
          rolelevel: this.condition.rolelevel
        }
        var that = this
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIPower/IsSectionsecretary', args, function(data) {
          that.issecretary = data.Data
        }, null, null, null)
      }
    },
    mounted: function() {
      this.condition.token = sessionStorage.getItem('token')
      this.condition.username = sessionStorage.getItem('username')
      this.condition.rolelevel = sessionStorage.getItem('rolelevel')
      this.condition.secid = sessionStorage.getItem('secid')
      this.record.ManageSecName = sessionStorage.getItem('managesecname')
      this.LoadManageSec()
      this.LoadRolePower()
      this.$refs.btnSearch.Search()
    }
  }
</script>

<style scoped="scoped">
  /deep/.el-input {
    width: 220px;
  }

  /deep/.el-table .cell {
    line-height: 25px;
  }
</style>
